/*
 * IMPORT
 */
import React from "react"; // NPM: React package.

/*
 * COMPONENTS
 */
import LandingPage from "components/landingpage/LandingPage";

/*
 * OJBECT
 */
const Index = () => {
  // Return
  return <LandingPage />;
};

/*
 * EXPORT
 */
export default Index;
